import style from "./PreLoader.module.scss";

export function PreLoader() {
    return (
        <div className={style.container}>
            <div className={style.logo}>
                <img src="/image/logo.svg" alt="logo" />
                <p className={style.name}>rocketproxy</p>
            </div>
        </div>
    )
}